import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetSalaryInfo, doSaveSalaryInfo, doDeleteSalaryInfo } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
class BatchSetAmontDiv extends React.Component {
	state = {
		changedValues基本信息: {},
	}

	handlerSave = () => {
		const { id, onSave, onClose } = this.props
		const { changedValues基本信息 } = this.state
		Tyan.doPostEvent({
			event: 'SaveBatchSetAmont',
			data: { id, changedValues基本信息 },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					onClose && onClose()
					onSave && onSave()
				}
			}
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	bSave = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		return [
			{ _float: '住房公积金（公司扣款%）', name: '公积金公司扣款比例', minWidth: '45% ', },
			{ _float: '住房公积金（个人扣款%）', name: '公积金个人扣款比例', minWidth: '45%', },

			{ _float: '养老保险（公司扣款%）', name: '养老保险公司扣款比例', minWidth: '45%', },
			{ _float: '养老保险（个人扣款%）', name: '养老保险个人扣款比例', minWidth: '45%', },
			{ _float: '失业保险（公司扣款%）', name: '失业保险公司扣款比例', minWidth: '45%', },
			{ _float: '失业保险（个人扣款%）', name: '失业保险个人扣款比例', minWidth: '45%', },
			{ _float: '工伤保险（公司扣款%）', name: '工伤保险公司扣款比例', minWidth: '45%', decimals: 3, },
			{ _float: '工伤保险（个人扣款%）', name: '工伤保险个人扣款比例', minWidth: '45%', },

			{ _float: '生育保险（公司扣款%）', name: '生育保险公司扣款比例', minWidth: '45%', },
			{ _float: '生育保险（个人扣款%）', name: '生育保险个人扣款比例', minWidth: '45%', },
			{ _float: '医疗保险（公司扣款%）', name: '医疗保险公司扣款比例', minWidth: '45%', },
			{ _float: '医疗保险（个人扣款%）', name: '医疗保险个人扣款比例', minWidth: '45%', },

			{ _float: '大额共济基金', name: '大额共济基金', minWidth: '95%', },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { errorMessage } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		return <Body data={this} maxWidth={'800'}
			controls={[
				{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
				{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
			]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
				]
			}
		/>
	}
}

export default connect()(BatchSetAmontDiv)